const httpsScheme = '^https://'
const alphanumericWithDashPeriodUnderscore = '[a-zA-Z0-9-._]'
const sharepointDomain = '.sharepoint.com'

// Regular expressions for some document urls

// https://drive.google.com/drive/u/0/<folder-name>
export const googleDrive = new RegExp(`${httpsScheme}drive\\.google\\.com/(.+)`)

// https://<organization-name>-my.sharepoint.com/personal/<user_name_domain>/_layouts/15/onedrive.aspx
export const oneDrive = new RegExp(
    `${httpsScheme}${alphanumericWithDashPeriodUnderscore}+-my${sharepointDomain}/personal/${alphanumericWithDashPeriodUnderscore}+/_layouts/15/.*`
)

// https://<organization-name>.sharepoint.com/<possible-paths>
export const microsoftSharepoint = new RegExp(
    `${httpsScheme}${alphanumericWithDashPeriodUnderscore}+${sharepointDomain}/(?:${alphanumericWithDashPeriodUnderscore}*/)*${alphanumericWithDashPeriodUnderscore}*`
)

// https://teams.microsoft.com/l/channel/<channel-id>/<channel-name>?groupId=<group-id>&tenantId=<tenant-id>
export const microsoftTeams = new RegExp(`${httpsScheme}teams\\.microsoft\\.com.*`)

// https://docs.google.com/document/d/<doc-id>/edit
export const googleDocs = new RegExp(
    `${httpsScheme}docs\\.google\\.com/document/d/${alphanumericWithDashPeriodUnderscore}+/edit`
)

// https://<organization-name>-my.sharepoint.com/:w:/r/personal/organization-name/_layouts/15/Doc.aspx?sourcedoc=%7B9E362851-3C86-4B14-80FC-364B8DA7AE33%7D&file=Document.docx&action=default
export const microsoftWordOnline = new RegExp(
    `${httpsScheme}${alphanumericWithDashPeriodUnderscore}+-my${sharepointDomain}/:w:.*`
)

// https://www.dropbox.com/s/<file-id-or-folder-id>/<file-name-or-folder-name>?dl=1
export const dropbox = new RegExp(
    `${httpsScheme}www\\.dropbox\\.com/${alphanumericWithDashPeriodUnderscore}+/${alphanumericWithDashPeriodUnderscore}+/${alphanumericWithDashPeriodUnderscore}+.*`
)

// https://www.notion.so/<organisation-name>/<page-tile-and-id>
export const notion = new RegExp(
    `${httpsScheme}www\\.notion\\.so/(?:${alphanumericWithDashPeriodUnderscore}*/)*${alphanumericWithDashPeriodUnderscore}*`
)

// https://<organization-name>-my.sharepoint.com/:x:/r/personal/user_organization-name/_layouts/15/Doc.aspx?sourcedoc=%7BD00B34F8-42D7-4FDA-A812-9B7C03C6DD40%7D&file=Book.xlsx&action=default
export const microsoftExcel = new RegExp(
    `${httpsScheme}${alphanumericWithDashPeriodUnderscore}+-my${sharepointDomain}/:x:.*`
)

// https://<organisation-name>-my.sharepoint.com/:p:/r/personal/user_organization-name/_layouts/15/Doc.aspx?sourcedoc=%7B376A698A-9A02-45F9-B6BD-ECB65767C550%7D&file=Presentation.pptx&action=edit
export const microsoftPowerpoint = new RegExp(
    `${httpsScheme}${alphanumericWithDashPeriodUnderscore}+-my${sharepointDomain}/:p:.*`
)

// https://docs.google.com/spreadsheets/d/<spreadsheet-id>/edit#gid=<sheet-id>
export const googleSheet = new RegExp(
    `${httpsScheme}docs\\.google\\.com/spreadsheets/d/${alphanumericWithDashPeriodUnderscore}+/edit.*`
)
